import { PrivateUserDetail, UserDetail } from 'modules/user-profile/types/user.types';
import { useQuery, UseQueryResult } from 'react-query';
import { UserService } from '../services/user.service';

/**
 * @param locale : Current Language used in portal
 * @returns  details of private users
 */
export const usePrivateUserDetails = (locale: string): UseQueryResult<PrivateUserDetail, Error> => {
  return useQuery(['user-details', locale], UserService.getPrivateUserDetails);
};

/**
 * @param locale : Current Language used in portal
 * @returns  details of commercial users
 */
export const useCommercialUserDetails = (locale: string): UseQueryResult => {
  return useQuery(['user-details', locale], UserService.getCommercialUserDetails);
};

export const useCustomerInformation = (): UseQueryResult<UserDetail, Error> => {
  return useQuery(['customer-information'], UserService.getCustomerInformation);
};
